import { render, staticRenderFns } from "./CartoGeneral.vue?vue&type=template&id=386ae7e2"
import script from "./CartoGeneral.vue?vue&type=script&lang=js"
export * from "./CartoGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports